import OspreyApiHelper from './helper'

export default class OspreyOffers {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }

    static put(path, params) {
        return OspreyApiHelper.genericPut(path, params.offer)
    }

    static post(path, params) {
        return OspreyApiHelper.genericPost(path, params)
    }

    static delete(...args) {
        return OspreyApiHelper.genericDelete(...args)
    }
}



// WEBPACK FOOTER //
// src/services/osprey-api/api-offers.js